import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import {ModuloHRAPI} from "../../../../api/ModuloHR/ModuloHRAPI";
import SelfCareDipendenteModal from "../ModuloHR/TimeoffRequests/SelfCareDipendenteModal";

export class DashboardTimeoffRequestsButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageOpen: false,
            staffList: [],
            staffLoading: true
        };
    }

    componentDidMount() {
        ModuloHRAPI.Staff.list()
            .then(staffList => {
                this.setState({staffList: staffList || [], staffLoading: false});
            })
            .catch(_ => {
                this.setState({staffList: [], staffLoading: false});
            });
    }

    handlePageOpen = _ => this.setState({pageOpen: true});
    handlePageClose = _ => this.setState({pageOpen: false});

    render() {
        if (this.state.staffLoading || !this.state.staffList.length) return '';

        return (
            <Fragment>
                <div className={"d-flex align-items-center justify-content-between p-3 border-top text-danger"} onClick={this.handlePageOpen}>
                    <span>
                        <FaSolidIcon name={"user"}/> &nbsp;
                        Area dipendente
                    </span>
                </div>
                <ModalPortalHOC>
                    {
                        this.state.pageOpen &&
                        <SelfCareDipendenteModal
                            staffList={this.state.staffList}
                            onDismiss={this.handlePageClose}
                            active={this.state.pageOpen}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

DashboardTimeoffRequestsButton.propTypes = {
    userNegozio: PropTypes.object
};
